<template>
  <button
    type="button"
    class="doc-download-btn"
    title="Download Document"
    :disabled="loading || !documentId"
    @click.stop="onDownload"
  >
    <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
    <span>{{ loading ? 'Downloading…' : 'Download' }}</span>
  </button>
</template>

<script>
import { downloadBookingDocument } from '@/utils/booking/downloadBookingDocuments'

export default {
  name: 'BookingDocumentDownloadButton',
  props: {
    bookingId: {
      type: String,
      default: ''
    },
    documentId: {
      type: String,
      default: ''
    },
    module: {
      type: String,
      required: true
    }
  },
  data () {
    return { loading: false }
  },
  methods: {
    async onDownload () {
      if (!this.bookingId || !this.documentId || this.loading) return
      this.loading = true
      try {
        await downloadBookingDocument({
          module: this.module,
          bookingId: this.bookingId,
          documentId: this.documentId
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Document',
          text: error.message || 'Failed to download this document',
          color: 'warning'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.doc-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 100px;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #f3f4f6;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.2;
}
.doc-download-btn:disabled {
  opacity: 0.6;
  cursor: progress;
}
.doc-download-btn:hover:not(:disabled) {
  background: #e5e7eb;
}
.theme-dark .doc-download-btn {
  background: var(--card-bg, #374151);
  color: var(--text-primary, #f9fafb);
}
</style>
